import { render, staticRenderFns } from "./recommendationList.vue?vue&type=template&id=78ddb216&scoped=true&"
import script from "./recommendationList.vue?vue&type=script&lang=ts&"
export * from "./recommendationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ddb216",
  null
  
)

export default component.exports